import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const DataTableIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 24 24'
    >
      <path
        d='M3 21V3H21V21H3ZM11 15H5V19H11V15ZM13 15V19H19V15H13ZM11 13V9H5V13H11ZM13 13H19V9H13V13ZM5 7H19V5H5V7Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};

export default DataTableIcon;
